import { defineStore } from 'pinia';
import type { CartSidebarState } from '~~/types/vuex/CartSidebar';

export const cartSidebarStore = defineStore('cartSidebar', {
  state: () => ({
    isCartSidebarOpen: false,
  }),
  actions: {
    toggleCartSidebar() {

      this.isCartSidebarOpen = !this.isCartSidebarOpen; 

    },
    closeCartSidebar() {

      this.isCartSidebarOpen = false; 

    },
  },
});
